var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('section',{staticClass:"page dashboard recruiter"},[_c('overview'),_c('progress-chart'),_c('rank')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }